import { render, staticRenderFns } from "./MonthlyScoreLock.vue?vue&type=template&id=1b2f8ea3&"
import script from "./MonthlyScoreLock.vue?vue&type=script&lang=js&"
export * from "./MonthlyScoreLock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports